import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import LoadingWrapper from '../LoadingWrapper';
import DataNotFound from '../DataNotFound';

const CommonTable = ({ id, columnsData=[], rowData=[], selectRow, defaultSorted=[], handleTableChange = () => {}, remote = { sort: false }, isLoading = false,emptyMessage='Data Not Found' ,className=''}) => {
  const validatedDefaultSorted = defaultSorted.map(sort => ({
    ...sort,
    order: (sort?.order === 'asc' || sort?.order === 'desc') ? sort?.order : 'asc' // Ensure valid order
  }));

  return (
    <div className={`v-middle table_height ${className}`}>
      <BootstrapTable
        keyField={id}
        data={rowData}
        columns={columnsData}
        selectRow={selectRow}
        defaultSorted={validatedDefaultSorted}
        onTableChange={handleTableChange}
        remote={remote}
        noDataIndication={() => isLoading ? <LoadingWrapper /> : <DataNotFound message={emptyMessage} />}
        striped
        hover
        condensed
      
      />
    </div>
  );
}

export default CommonTable;